import type { SVGProps } from 'react';

const paths = {
  inbox: 'M3 12l2.5-7h13L21 12m-18 0v6a1 1 0 001 1h16a1 1 0 001-1v-6m-18 0h5l1 2h6l1-2h5',
  file: 'M7 3h7l5 5v12a1 1 0 01-1 1H7a1 1 0 01-1-1V4a1 1 0 011-1zm7 0v5h5M9 13h6M9 17h6',
  chart: 'M4 20V10m6 10V4m6 16v-7m4 7H3',
  users: 'M16 19v-1a4 4 0 00-4-4H7a4 4 0 00-4 4v1m13-9a3 3 0 100-6m5 15v-1a4 4 0 00-3-3.9M9.5 10a3 3 0 100-6 3 3 0 000 6z',
  settings: 'M12 15a3 3 0 100-6 3 3 0 000 6zm7.4-3a7.4 7.4 0 00-.1-1.2l2-1.5-2-3.4-2.3 1a7.6 7.6 0 00-2-1.2L14.6 3h-4l-.4 2.7a7.6 7.6 0 00-2 1.2l-2.3-1-2 3.4 2 1.5a7.4 7.4 0 000 2.4l-2 1.5 2 3.4 2.3-1c.6.5 1.3.9 2 1.2l.4 2.7h4l.4-2.7c.7-.3 1.4-.7 2-1.2l2.3 1 2-3.4-2-1.5c.1-.4.1-.8.1-1.2z',
  search: 'M11 18a7 7 0 100-14 7 7 0 000 14zm9 3l-4.5-4.5',
  x: 'M6 6l12 12M18 6L6 18',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  chevronRight: 'M9 5l7 7-7 7',
  chevronLeft: 'M15 5l-7 7 7 7',
  chevronDown: 'M5 9l7 7 7-7',
  chevronUp: 'M5 15l7-7 7 7',
  alert: 'M12 9v4m0 4h.01M10.3 3.9L2.4 18a2 2 0 001.7 3h15.8a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z',
  info: 'M12 16v-5m0-3h.01M12 22a10 10 0 100-20 10 10 0 000 20z',
  sun: 'M12 16a4 4 0 100-8 4 4 0 000 8zm0-13v2m0 14v2M5 5l1.4 1.4m11.2 11.2L19 19M3 12h2m14 0h2M5 19l1.4-1.4M17.6 6.4L19 5',
  moon: 'M20 14.5A8 8 0 019.5 4 8 8 0 1020 14.5z',
  monitor: 'M3 5h18v11H3zM8 21h8m-4-5v5',
  menu: 'M4 6h16M4 12h16M4 18h16',
  globe: 'M12 22a10 10 0 100-20 10 10 0 000 20zM2 12h20M12 2a15 15 0 010 20 15 15 0 010-20z',
  clock: 'M12 22a10 10 0 100-20 10 10 0 000 20zm0-15v5l3 2',
  mail: 'M3 6h18v12H3zm0 1l9 7 9-7',
  building: 'M5 21V4h9v17M14 9h5v12M3 21h18M8 8h3M8 12h3M8 16h3',
  external: 'M14 4h6v6m0-6L10 14M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5',
  plus: 'M12 5v14M5 12h14',
  command: 'M9 9V6a3 3 0 10-3 3h3zm0 0h6m-6 0v6m6-6V6a3 3 0 113 3h-3zm0 0v6m0 0h3a3 3 0 11-3 3v-3zm0 0H9m0 0H6a3 3 0 103 3v-3z',
  logout: 'M15 17l5-5-5-5m5 5H9m4 8H5a1 1 0 01-1-1V5a1 1 0 011-1h8',
  activity: 'M3 12h4l3-8 4 16 3-8h4',
  eye: 'M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12zm10 3a3 3 0 100-6 3 3 0 000 6z',
  layout: 'M3 4h18v16H3zM9 4v16M9 10h12',
  send: 'M21 3L10 14M21 3l-7 18-4-7-7-4 18-7z',
  lock: 'M6 11h12v9H6zM8 11V8a4 4 0 118 0v3',
  refresh: 'M20 11a8 8 0 00-14.9-3M4 4v4h4M4 13a8 8 0 0014.9 3M20 20v-4h-4',
  kanban: 'M4 4h4.5v16H4zM9.75 4h4.5v10h-4.5zM15.5 4H20v7h-4.5z',
  briefcase: 'M4 7h16v12H4zM9 7V5a1 1 0 011-1h4a1 1 0 011 1v2M4 13h16',
  checkSquare: 'M4 4h16v16H4zM8.5 12l2.5 2.5 4.5-5',
  contact: 'M12 12a4 4 0 100-8 4 4 0 000 8zm-8 9v-1a5 5 0 015-5h6a5 5 0 015 5v1',
  image: 'M3 5h18v14H3zM3 16l5-5 4 4 3-3 6 6M8.5 9.5h.01',
  book: 'M12 6c-2-1.5-5-2-8-2v14c3 0 6 .5 8 2 2-1.5 5-2 8-2V4c-3 0-6 .5-8 2zM12 6v14',
  megaphone: 'M3 10v4h4l9 5V5l-9 5H3zM19 9a4 4 0 010 6',
  target: 'M12 22a10 10 0 100-20 10 10 0 000 20zm0-5a5 5 0 100-10 5 5 0 000 10zm0-5h.01',
  clipboard: 'M9 4h6v3H9zM7 5.5H5a1 1 0 00-1 1V20a1 1 0 001 1h14a1 1 0 001-1V6.5a1 1 0 00-1-1h-2M9 12h6M9 16h6',
} as const;

export type IconName = keyof typeof paths;

export function Icon({ name, size = 16, ...rest }: { name: IconName; size?: 16 | 20 | 24 } & Omit<SVGProps<SVGSVGElement>, 'name'>) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={size === 16 ? 2 : 1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...rest}>
      <path d={paths[name]} />
    </svg>
  );
}
